/**
 * Procurement Demo — the "Sources" line under a Nami answer.
 *
 * THROWAWAY DEMO CODE. Answers cite the agreement section, the bid section or
 * the supplier page behind them. In the chat each citation becomes a markdown
 * link to that place in the app (the registrar turns these links into in-app
 * navigation). Citations that point at something already on screen, such as a
 * scorecard on the page the user is on, have no link and are left out.
 */

import type { AskCitation } from '../ask/types';
import { isContractId } from '../data/contracts';
import { shortTitleFor } from '../pages/contracts/ask-documents';

export interface SourceLink {
  label: string;
  href: string;
}

/** Link to the clause in the agreement, which opens highlighted. */
export function contractSourceLink(citation: AskCitation): SourceLink | null {
  const { documentId, ref } = citation;
  if (!isContractId(documentId)) return null;
  return {
    label: `${shortTitleFor(documentId)} §${ref}`,
    href: `/procurement/contracts/${documentId}?clause=${documentId}:${ref}`,
  };
}

/** "\n\nSources: [label](href) · ..." or an empty string when there are no links. */
export function sourcesLine(links: (SourceLink | null)[]): string {
  const seen = new Set<string>();
  const unique: SourceLink[] = [];
  for (const link of links) {
    if (link === null || seen.has(link.href)) continue;
    seen.add(link.href);
    unique.push(link);
  }
  if (unique.length === 0) return '';
  const items = unique.map(({ label, href }) => `[${label}](${href})`);
  return `\n\nSources: ${items.join(' · ')}`;
}
